











































































































import { defineComponent, reactive, toRefs, computed, ref, onMounted, onBeforeUnmount } from '@vue/composition-api';
import * as Common from "../../commons/common"
import http from "../../plugins/http";
import SaitenEditTab from "../../components/SaitenEditTab.vue";
import DropArea from "../../components/DropArea.vue";
import AlertArea from "../../components/AlertArea.vue";
import CustomConfirm from "../../components/CustomConfirmModal.vue";
import { BModal } from 'bootstrap-vue';
import { SheetField } from "../../modules/teacher/DigitalPaperFieldEdit"

export interface Data {
  tabNo: number
  sheet_group_key: string
  sheet: any,
  sheetFields: SheetField[],
  part1Caches: any[],
  errors: any[],
  file: any
}

export default defineComponent({
  components: {
    "saiten-edit-tab": SaitenEditTab,
    "drop-area": DropArea,
    "alert-area": AlertArea,
  },
  setup(props, context){

    const confirmUploadRef = ref<InstanceType<typeof CustomConfirm>>();
    const confirmChangeAllotRef = ref<InstanceType<typeof CustomConfirm>>();

    /******************************
     * data
     ******************************/

    const state = reactive<Data>({
      tabNo: 1,
      sheet_group_key: null,
      sheet: {},
      sheetFields: [],
      part1Caches: [],
      errors: [],
      file: null,
    });

    /******************************
     * kind:0(設問)に絞り込んだsheet_fields
     ******************************/

    const questionSheetFields = computed(() => {
      return state.sheetFields.filter(x => x.kind == 0);
    });

    /******************************
     * 合計点
     ******************************/

    const totalAllot = computed(() => {
      var sum = 0;
      for(let allot of questionSheetFields.value.map(x => x.allot)){
        sum += Number(allot) ? Number(allot) : 0;
      }
      return sum;
    });

    /******************************
     * 文字認識種別
     ******************************/

    const recogTypes = computed(() => {
      return [{value: null, text: "-"}].concat(Common.GetComboboxRecogTypeArray());
    });

    /******************************
     * テンプレートダウンロード
     ******************************/

    const downloadFieldTemplate = async () => {
      await http.get(`/api/teacher/digital_paper_field_edit/download_field_template/${state.sheet_group_key}`, {responseType: 'arraybuffer'}).then(response => {
        const blob = new Blob([response.data], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
        const a = document.createElement('a');
        a.href = window.URL.createObjectURL(blob);
        a.download = `field_template.xlsx`;
        a.click();
      })
      .catch(error=>{
        if(error.response.status == 422){
          const errorData = JSON.parse((new TextDecoder).decode(new Uint8Array(error.response.data)));
          state.errors = errorData.errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }
      });
    }

    /******************************
     * エクセルファイルドロップ
     ******************************/

     const onDrop = async (file: any) => {
      state.file = file;
      await http.get(`/api/teacher/field_edit/is_exists_sheet_activity/${state.sheet_group_key}`).then(response => {
        if(response.data.result){
          confirmUploadRef.value.show();
        }else{
          if(window.confirm("ファイルをアップロードします。\nよろしいですか？")){
            upload();
          }
        }
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }
      });
    }

    /******************************
     * ファイルアップロード
     ******************************/

    const upload =  async () => {      

      confirmUploadRef.value.hide();
      
      let fd = new FormData();
      fd.append('upload[file]', state.file);

      context.root.$store.dispatch("showOverlay", "ファイル読み込み中");

      await http.post(`/api/teacher/digital_paper_field_edit/upload/${state.sheet_group_key}`, fd).then(response => {
        state.sheet = response.data.sheet;
        state.sheetFields = response.data.sheet_fields.map((x: any) => new SheetField(x));
        context.root.$store.commit("setIsRecogPositionEditEnable", state.sheet.is_recog_position_edit_enable);

        alert("アップロードが完了しました。");
        state.errors = [];
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }
      });

      context.root.$store.dispatch("hideOverlay");
    }

    /******************************
     * 保存ボタンクリック
     ******************************/

    const saveClick = async () => {

      if(state.sheetFields.filter(x => x.allot != x.allot_cache).length > 0){
        const param = {
          sheet_field_ids: state.sheetFields.filter(x => x.allot != x.allot_cache).map(x => x.id)
        }
        await http.post(`/api/teacher/field_edit/is_exists_scored_field_activity/${state.sheet_group_key}`, param).then(async response => {
          if(response.data.result){
            confirmChangeAllotRef.value.show();
          }else{
            if(!window.confirm("問題構造を保存します。よろしいですか？")){
              return;
            }
            await save();
          }
        })
        .catch(error=>{
          if(error.response.status == 422){
            state.errors = error.response.data.errors;
          }else{
            state.errors = ["予期せぬ例外が発生しました。"];
          }
        });
      }else{
        if(!window.confirm("問題構造を保存します。よろしいですか？")){
          return;
        }
        await save();
      }
    }

    /******************************
    * 保存API実行
    ******************************/

    const save = async () => {

      confirmChangeAllotRef.value.hide();

      context.root.$store.dispatch("showOverlay");
      
      await http.post(`/api/teacher/digital_paper_field_edit/update/${state.sheet_group_key}`, {sheet_fields: questionSheetFields.value}).then(response => {
        context.root.$store.commit("setIsRecogPositionEditEnable", response.data.sheet.is_recog_position_edit_enable);
        if(state.sheet.is_print_part1 && state.sheet.score_positions_completed && questionSheetFields.value.filter(x => !state.part1Caches.includes(x.part1)).length > 0){
          alert("処理が完了しました。新しい大問が追加されています。採点枠の設定画面から追加された大問の枠を設定してください。");
        }else{
          alert("処理が完了しました。");
        }
        context.root.$router.push(`/teacher_site/correct_image_upload/${state.sheet_group_key}`).catch(err => {});
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }
      });

      context.root.$store.dispatch("hideOverlay");
    }


    /******************************
     * mounted
     ******************************/
    
    onMounted(async () => {
      context.root.$store.commit("setIsHeaderDisp", false);
      context.root.$store.dispatch("showOverlay", "データ取得中... しばらくお待ちください。");
      state.sheet_group_key = context.root.$route.params.sheet_group_key;

      // APIで登録済み試験情報取得
      await http.get(`/api/teacher/digital_paper_field_edit?sheet_group_key=${state.sheet_group_key}`).then(response => {
        state.sheet = response.data.sheet;
        state.sheetFields = response.data.sheet_fields.map((x: any) => new SheetField(x));
        state.sheetFields.forEach((x: any) => x["allot_cache"] = x.allot);
        state.part1Caches = [...new Set(questionSheetFields.value.map(x => x.part1))];
      })
      .catch(error=>{
        // 後続処理不能のため一覧に戻る
        if(error.response.status == 422){
          alert(`試験情報の取得処理に失敗しました。試験一覧に戻ります。\n${error.response.data.errors[0]}`);
        }else{
          alert(`試験情報の取得処理に失敗しました。試験一覧に戻ります。`);
        }
        context.root.$store.dispatch("goSheetList");
      });

      context.root.$store.dispatch("hideOverlay");
    })

    return {
      ...toRefs(state),
      confirmUploadRef,
      confirmChangeAllotRef,
      questionSheetFields,
      totalAllot,
      recogTypes,
      downloadFieldTemplate,
      upload,
      saveClick,
      save,
      onDrop,
    }
  }
})
